import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { StatusInputWrapper } from "../../../../../../shared/components/StatusInputWrapper";
import { getNestedProperty } from "../../../../../../shared/helpers/getNestedProperty";
// import { getNestedProperty } from '../../../../helpers/getNestedProperty';
// import { StatusInputWrapper } from '../StatusInputWrapper';

const InfoTextFormComponent = ({
  t,
  label,
  reduxAppProperty,
  changeObjectPropertyAction,
  fieldName,
  validate,
  error,
  isValid,
  helperText,
  setIsError,
  maxLength,
  isPhone,
  keypadType
}) => {
  // const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false);

  const fieldValue = useSelector(
    (state) => getNestedProperty(state.app, reduxAppProperty)[fieldName]
  );

  const handleSinNumber = (e) => {
    try {
      var x = e.currentTarget.value
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,3})/);
      let sinNumberParsed = !x[2]
        ? x[1]
        : x[1] + " " + x[2] + (x[3] ? " " + x[3] : "");
      changeObjectPropertyAction(fieldName, sinNumberParsed);
      validate(sinNumberParsed, null);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const onBlurSinNumber = (e) => {
    try {
      SetIsFocussed(false);
      var x = e.currentTarget.value
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,3})/);
      let sinNumberParsed = !x[2]
        ? x[1]
        : x[1] + " " + x[2] + (x[3] ? " " + x[3] : "");
      changeObjectPropertyAction(fieldName, sinNumberParsed);
      validate(sinNumberParsed, null);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  return (
    <StatusInputWrapper
      isValid={isValid}
      errorMsg={error}
      t={t}
      label={label}
      isFocussed={isFocussed}
      id={`${reduxAppProperty}-${fieldName}`}
      name={`${reduxAppProperty}-${fieldName}`}
      // type={isNumeric ? "tel" : "text"}
      // type="text"
      // inputMode={isNumeric ? "numeric" : "text"}
      keypadType={keypadType}
      helperText={helperText}
      customClasses={"fw-20"}
      aria-describedby={`${reduxAppProperty}-${fieldName}`}
      onChange={handleSinNumber}
      onBlur={onBlurSinNumber}
      onFocus={() => SetIsFocussed(true)}
      value={fieldValue}
      autoComplete="off"
      maxLength={maxLength ? maxLength : "50"}
      // pattern="[0-9]*"
    />
  );
};

export default withTranslation("common")(InfoTextFormComponent);
